angular.module('bmsApp.settings').factory('OnlineSaleStatusSvc', function ($http, $log, $window, $q, CRUDSvc) {

		function read(params) {
			return CRUDSvc.get('api/settings/online-status/read', params);
		}

		function save(params) {
			return CRUDSvc.post('api/settings/online-status/save', params);
		}

		return {
			read: read,
			save: save,
		};

	});
